import React, { useMemo, useCallback } from 'react';
import { CForm, CFormLabel, CFormInput, CRow, CCol, CButton } from '@coreui/react';
import { useNavigate } from 'react-router-dom';

const AccountsFormComponents = ({ data, type }) => {
  const navigate = useNavigate();

  const isReadOnly = type === 'accountPage';

  const fields = useMemo(() => {
    if (!data) return [];

    const ownerFullName = [data?.owner?.lastName, data?.owner?.firstName].filter(Boolean).join(' ') || data?.owner?.firstName || '';

    const formatValue = (value) => {
      if (value === null || value === undefined || value === '') return '';
      if (typeof value === 'boolean') return value ? 'Так' : 'Ні';
      return String(value);
    };

    return [
      { key: 'id', label: 'ID', value: formatValue(data?.id) },
      { key: 'number', label: 'Номер рахунку', value: formatValue(data?.number) },
      { key: 'name', label: 'Назва', value: formatValue(data?.name) },
      { key: 'type', label: 'Тип', value: formatValue(data?.type) },
      { key: 'pib', label: 'ПІБ власника', value: formatValue(ownerFullName) },
      { key: 'phone', label: 'Телефон', value: formatValue(data?.owner?.phone) },
      { key: 'email', label: 'Email', value: formatValue(data?.owner?.email) },
      { key: 'fullAddress', label: 'Адреса', value: formatValue(data?.fullAddress || data?.mainFullAddress) },
      { key: 'eic', label: 'EIC', value: formatValue(data?.eic) },
      { key: 'counter', label: 'Лічильник', value: formatValue(data?.counter) },
      { key: 'statusLight', label: 'Статус', value: formatValue(data?.accounts?.statusLight) },
      { key: 'active', label: 'Активний', value: formatValue(data?.active) },
      { key: 'isMain', label: 'Основний', value: formatValue(data?.isMain) },
    ];
  }, [data]);

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  if (!data) {
    return (
      <CForm className="mb-3">
        <p className="text-medium-emphasis mb-3">Дані особового рахунку відсутні.</p>
        <CButton color="secondary" variant="outline" onClick={handleBack}>
          Повернутись
        </CButton>
      </CForm>
    );
  }

  return (
    <CForm className="mb-3">
      <CRow className="g-3">
        {fields.map(({ key, label, value }) => (
          <CCol md={6} key={key}>
            <CFormLabel>{label}</CFormLabel>
            <CFormInput
              type="text"
              value={value}
              disabled={isReadOnly}
              readOnly={isReadOnly}
              autoComplete="off"
            />
          </CCol>
        ))}
      </CRow>
      <div className="d-flex justify-content-start mt-4">
        <CButton color="secondary" variant="outline" onClick={handleBack}>
          Повернутись
        </CButton>
      </div>
    </CForm>
  );
};

export default AccountsFormComponents;